<template>
  <div>
    <b-table
      striped
      hover
      responsive
      class="position-relative"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      sort-icon-left
      :items="providers"
      show-empty
      :empty-text="$t('errors.emptyProvidersTable.title')"
      :empty-filtered-text="$t('errors.emptyProvidersTable.title')"
      :fields="fields"
    >
      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle mr-2" />
          <strong>{{ $t("Carregant") }}...</strong>
        </div>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">
        <b-dropdown variant="link" no-caret>
          <template #button-content>
            <feather-icon
              icon="MoreVerticalIcon"
              size="16"
              class="align-middle text-body"
            />
          </template>

          <b-dropdown-item @click="onEditProviderClicked(data.item.uuid)">
            <feather-icon icon="EditIcon" />
            <span class="align-middle ml-50">Edita</span>
          </b-dropdown-item>

          <b-dropdown-item @click="confirmDeleteProvider(data.item.uuid)">
            <feather-icon icon="TrashIcon" />
            <span class="align-middle ml-50">Elimina</span>
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>
  </div>
</template>

<script>
import { BTable, BDropdown, BDropdownItem } from "bootstrap-vue";

export default {
  components: {
    BTable,
    BDropdown,
    BDropdownItem,
  },
  props: {
    providers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isBusy: false,
      sortBy: "name",
      sortDesc: false,

      totalRows: 1,

      fields: [
        { key: "name", label: this.$t("Nom"), sortable: true },
        { key: "idNumber", label: this.$t("Identificador"), sortable: true },
        { key: "type", label: this.$t("Tipus"), sortable: true },
        { key: "actions", label: this.$t("Accions") },
      ],
    };
  },
  methods: {
    onEditProviderClicked(providerUuid) {
      this.$emit("edit-provider-click", providerUuid);
    },
    confirmDeleteProvider(providerUuid) {
      this.$swal({
        title: "Eliminar proveïdor",
        text: "Estàs a punt d'eliminar aquest proveïdor, estàs segur/a?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Elimina",
        cancelButtonText: "Cancel·la",
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) this.deleteProvider(providerUuid);
      });
    },
    deleteProvider(providerUuid) {
      this.$store.dispatch("app/setLoading", true);
      this.$store
        .dispatch("contract/deleteProvider", providerUuid)
        .then(() => this.$emit("provider-deleted"))
        .catch(() => {
          this.$emit("provider-deleted-error");
          // TODO: Log error in Sentry? Only if is not logged in the store
        })
        .finally(() => this.$store.dispatch("app/setLoading", false));
    },
  },
};
</script>
